import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import BlogGen from './BlogGen';

export default function Blog() {
  return (
    <>
        <Navbar />
        <BlogGen />
        <Footer />
        <Copyright />
    </>
  )
}
